/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import CloseButton from '../Buttons/CloseButton';
import Loader from '../Loader';
import HtmlDiff from 'htmldiff-js';
import './style.scoped.scss';
import { FaDownload } from 'react-icons/fa';
import { getPagesByDocumentID } from '../../services/axios';
import { connect } from 'react-redux';

const mapStateToProps = () => ({});

const connector = connect(mapStateToProps, null);

const VersionComparison = ({
  handleCloseComparison,
  currentDocument,
  docToCompare,
}) => {
  const [loading, setLoading] = useState(true);
  const [docLoading, setDocLoading] = useState(false);
  const [currentDoc, setCurrentDoc] = useState();
  const [previousDoc, setPreviousDoc] = useState();
  const [isChecked, setIsChecked] = useState(true);
  const [showCurrentVersion, setShowCurrentVersion] = useState(false);

  const formatArrayToString = (data) => {
    return data
      .map((page) => `<h4>${page.title}</h4>\n${page.HTMLContent}\n`)
      .join('\n');
  };

  const getDocToCompare = async (previousVersion) => {
    const allPages = await getPagesByDocumentID(previousVersion.id, previousVersion.slug);
    const html = [];
    allPages.map((page) =>
      html.push({ title: page.title, HTMLContent: page.HTMLContent })
    );
    setPreviousDoc(formatArrayToString(html));
    setLoading(false);
    setDocLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    if (currentDocument) {
      const html = [];
      currentDocument.pages.map((page) =>
        html.push({ title: page.title, HTMLContent: page.HTMLContent })
      );
      setCurrentDoc(formatArrayToString(html));
    }

    if (docToCompare) getDocToCompare(docToCompare);
  }, [currentDocument, docToCompare]);

  const handleDownload = (e) => {
    e.preventDefault();
    const element = document.createElement('a');
    const blob = new Blob([convertToWord()], {
      type: 'application/msword',
    });
    const url = URL.createObjectURL(blob);
    element.href = url;
    element.download = 'Document Changes.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    URL.revokeObjectURL(url);
  };

  const convertToWord = () => {
    const header = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>`;
    const footer = `</body></html>`;

    return `${header}${HtmlDiff.execute(previousDoc, currentDoc)}${footer}`;
  };

  const handleToggle = () => {
    setShowCurrentVersion((current) => !current);
  };

  const handleDocSelected = (value) => {
    setDocLoading(true);
    getDocToCompare({ id: value });
  };

  return (
    <React.Fragment>
      {!loading ? (
        <div className='versionWrapper'>
          <div className='buttonsWrapper'>
            <div className='tabButtons'>
              <button
                className={`tabButon borderRadiusLeft${
                  isChecked ? ' activeBtn' : ''
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  setIsChecked(true);
                }}
              >
                Show Markup
              </button>
              <button
                className={`tabButon borderRadiusRight${
                  isChecked ? '' : ' activeBtn'
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  setIsChecked(false);
                }}
              >
                Side by Side
              </button>
            </div>

            <div className='previousVersion'>
              <div className='dropdownOption'>
                <span>Select Previous Version</span>
                <div className='selectVersion'>
                  <select
                    className='form-control'
                    onChange={(option) =>
                      handleDocSelected(option.target.value)
                    }
                  >
                    {currentDocument &&
                      currentDocument.previousVersionsList.length > 0 &&
                      currentDocument.previousVersionsList
                        .sort((a, b) =>
                          a.publishedDate > b.publishedDate ? 1 : -1
                        )
                        .map((doc, index) => (
                          <option value={doc.id} key={index}>
                            {doc.title}
                            {doc.version ? ` - Version: ${doc.version}` : null}
                            {doc.versionDate
                              ? ` - Version Date: ${doc.versionDate.toLocaleDateString()}`
                              : null}
                          </option>
                        ))}
                  </select>
                </div>
              </div>

              {isChecked && (
                <div className='toggleWrapper'>
                  <div className='toggleContainer'>
                    <div
                      className={`sliderContainer ${
                        !showCurrentVersion ? 'disabledBackground' : ''
                      }`}
                      onClick={handleToggle}
                    >
                      <div
                        className={`slider ${
                          showCurrentVersion ? 'active' : ''
                        }`}
                      />
                    </div>
                    <span className='toggleLabel'>View Current Version</span>
                  </div>
                </div>
              )}
            </div>

            <div className='buttonsRight'>
              <button
                className='donwloadBtn mr-3'
                onClick={handleDownload}
                title='Download Document Changes'
              >
                {/* Download Document Changes */}
                <FaDownload />
              </button>
              <CloseButton
                handleClose={handleCloseComparison}
                title='Return to Document'
              />
            </div>
          </div>

          {isChecked && (
            <div
              className='d-flex flex-row align-items-center'
              style={{ margin: '1rem' }}
            >
              <div className='greenBox'></div>
              <span className='ml-2'>Insertions</span>
              <div className='redBox ml-4'></div>
              <span className='ml-2'>Deletions</span>
            </div>
          )}

          {isChecked ? (
            showCurrentVersion ? (
              <div className='markupWrapper'>
                <div className='leftSide'>
                  <div className='docWrapper'>
                    <div className='col-6'>
                      <h3 className='docWrapper__title'>Current Version</h3>
                    </div>
                  </div>
                  <div className='mt-3'>
                    <div className='col-12'>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: currentDoc,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='rigthSide'>
                  <div className='docWrapper'>
                    <div className='col-6'>
                      <h3 className='docWrapper__title'>Markup</h3>
                    </div>
                  </div>
                  <div className='mt-3'>
                    <div className='col-12'>
                      {docLoading ? (
                        <div className='loadingDoc'>
                          <div className='inner-load'>
                            <Loader text='Loading Document...' />
                          </div>
                        </div>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: HtmlDiff.execute(previousDoc, currentDoc),
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`contentWrapper row mt-4 ${
                  docLoading ? 'flex-column' : ''
                }`}
              >
                <div className='m-2'>
                  {docLoading ? (
                    <div className='loadingDoc w-100'>
                      <div className='inner-load'>
                        <Loader text='Loading Document...' />
                      </div>
                    </div>
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: HtmlDiff.execute(previousDoc, currentDoc),
                      }}
                    />
                  )}
                </div>
              </div>
            )
          ) : (
            <div className='contentWrapper'>
              <div className='leftSide'>
                <div className='docWrapper'>
                  <div className='col-6'>
                    <h3 className='docWrapper__title'>Current Version</h3>
                  </div>
                </div>
                <div className='mt-3'>
                  <div className='col-12'>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: currentDoc,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='rigthSide'>
                <div className='docWrapper'>
                  <div className='col-6'>
                    <h3 className='docWrapper__title'>Previous Version</h3>
                  </div>
                </div>
                <div className='mt-3'>
                  <div className='col-12'>
                    {docLoading ? (
                      <div className='loadingDoc'>
                        <div className='inner-load'>
                          <Loader text='Loading Document...' />
                        </div>
                      </div>
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: previousDoc,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className='inner-load'>
          <Loader text='Assembling Comparison...' />
        </div>
      )}
    </React.Fragment>
  );
};

export default connector(VersionComparison);
